


























































import {
  defineComponent, PropType, onMounted, computed,
} from '@vue/composition-api';
import { formatFAmount } from '@/shared/utils/finacalNumber';
import { Button } from '@hb/coffee';
import { RightArrowOutline12 } from '@hb/coffee-icons';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { navigateToUrlIfInProject } from '@/api/native/utils';
import { MiddleIncomeResponse, DEFAULT_UBT_CARD_NAME_BY_BUSINESS_TYPE, MiddleIncomeBusinessTypeEnum } from '../../../../types';


export default defineComponent({
  name: 'MiddleIncomeCard',
  props: {
    middleIncomeBusiness: {
      type: Object as PropType<MiddleIncomeResponse>,
      required: true,
    },
    isBigCard: {
      type: Boolean,
      default: true,
    },
    cardPosition: {
      type: Number,
      required: true,
    },
  },
  components: {
    Button,
    RightArrowOutline12,
  },
  setup(props) {
    const { cardPosition, isBigCard } = props;
    const cardStyle = isBigCard ? 'large' : 'small';
    const middleIncomeBusinessData = computed(() => props?.middleIncomeBusiness || {});

    /**
     * 处理卡片点击事件
     * 贷超半流程链接用 router 跳转，其他链接用 openThirdPage 打开
     */
    const handleClick = () => {
      const { jumpUrl, businessType, buttonText } = props?.middleIncomeBusiness;
      if (businessType === MiddleIncomeBusinessTypeEnum.SHOPPING_MALL) {
        ubtSetupPageButton(DEFAULT_UBT_CARD_NAME_BY_BUSINESS_TYPE[businessType], {
          cardStyle,
          cardPosition,
          buttonText,
        });
      } else {
        ubtSetupPageButton(DEFAULT_UBT_CARD_NAME_BY_BUSINESS_TYPE[businessType], {
          cardStyle,
          cardPosition,
        });
      }
      if (jumpUrl) {
        navigateToUrlIfInProject(jumpUrl);
      }
    };
    onMounted(() => {
      const { businessType, buttonText } = props?.middleIncomeBusiness;
      if (businessType === MiddleIncomeBusinessTypeEnum.SHOPPING_MALL) {
        ubtSetupModuleExpose(DEFAULT_UBT_CARD_NAME_BY_BUSINESS_TYPE[businessType], {
          cardStyle,
          cardPosition,
          buttonText,
        });
      } else {
        ubtSetupModuleExpose(DEFAULT_UBT_CARD_NAME_BY_BUSINESS_TYPE[businessType], {
          cardStyle,
          cardPosition,
        });
      }
    });
    return {
      middleIncomeBusinessData,
      formatFAmount,
      handleClick,
      ubtSetupModuleExpose,
      ubtSetupPageButton,
    };
  },
});

